// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { SchoolTagCoachFragmentDoc } from '../../coach/__generated-gql-types__/SchoolTag.generated';
import { CompanyTagCoachFragmentDoc } from '../../coach/__generated-gql-types__/CompanyTag.generated';
import { CoachCardPackageCarouselOfferingPackageFragmentDoc } from './CoachCardPackageCarousel.generated';
export type CoachCardCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  tier: Types.SkuTier;
  newExperience?: boolean | null;
  bio?: string | null;
  hourlyRate?: number | null;
  reviewTotal: number;
  averageReviewRate: number;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    headline?: string | null;
    testScore?: number | null;
    qualifications?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      slug: string;
      name: string;
      goal: Types.GoalName;
    };
  }> | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
  } | null;
  educationExperiences?: Array<{
    __typename?: 'Education';
    admissionCommittee: boolean;
    isFeatured?: boolean | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  professionalExperiences?: Array<{
    __typename?: 'ProfessionalExperience';
    experienceType?: Types.ExperienceType | null;
    isFeatured?: boolean | null;
    company: {
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    };
    endAt?: { __typename?: 'MonthYear'; year: number } | null;
  }> | null;
  schoolAdmissionInfoList?: Array<{
    __typename?: 'SchoolAdmissionInfo';
    status?: Types.SchoolAdmissionStatus | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  companiesAdmitted?: Array<{
    __typename?: 'Company';
    id?: string | null;
    name: string;
    domain?: string | null;
    logoLink?: string | null;
  }> | null;
};

export type CoachCardHydratedCoachFieldsFragment = {
  __typename?: 'Coach';
  id: string;
  tier: Types.SkuTier;
  hourlyRate?: number | null;
};

export type CoachCardOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  slug?: string | null;
  name: string;
  imageLink?: string | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    price: number;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
};

export type CoachCardSkuFragment = {
  __typename?: 'Sku';
  id: string;
  tier: Types.SkuTier;
  unitPrice: number;
};

export const CoachCardCoachFragmentDoc = gql`
  fragment CoachCard_Coach on Coach {
    id
    slug
    tier
    newExperience
    user {
      id
      firstName
      lastName
      pictureLink
    }
    categoryInformationList(showHidden: false) {
      category {
        id
        slug
        name
        goal
      }
      headline
      testScore
      qualifications
    }
    bio
    hourlyRate
    reviewTotal
    averageReviewRate
    availability {
      nextAvailableAt
    }
    educationExperiences {
      admissionCommittee
    }
    professionalExperiences {
      experienceType
    }
    ...SchoolTag_Coach
    ...CompanyTag_Coach
  }
  ${SchoolTagCoachFragmentDoc}
  ${CompanyTagCoachFragmentDoc}
`;
export const CoachCardHydratedCoachFieldsFragmentDoc = gql`
  fragment CoachCard_HydratedCoachFields on Coach {
    id
    tier
    hourlyRate
  }
`;
export const CoachCardOfferingPackageFragmentDoc = gql`
  fragment CoachCard_OfferingPackage on OfferingPackage {
    ...CoachCardPackageCarousel_OfferingPackage
  }
  ${CoachCardPackageCarouselOfferingPackageFragmentDoc}
`;
export const CoachCardSkuFragmentDoc = gql`
  fragment CoachCard_Sku on Sku {
    id
    tier
    unitPrice
  }
`;
